let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2TH1b")).then(() => parcelRequire('jgLB9'));